export default __webpack_public_path__ + "static/media/main_logo.24d98257.png";